<script>
    import { getContext, onMount, tick } from 'svelte'
    import { uuid } from '@manaakiwhenua/frag-svelte/src/uuid'
    import { mapToSrcSync, transparentSrc } from './print-map'
    import VectorSource from 'ol/source/Vector'
    import VectorLayer from 'ol/layer/Vector'
    import {Group} from 'ol/layer';
    import {Map as OlMap, View} from 'ol';
    import './proj';
    import Point from 'ol/geom/Point'
    import {ScaleLine} from 'ol/control';
    import {wmtsMapHost, mapUnitWMSLayer, resolutions, wmtsLayer} from "./layers";
    import {vectorStyle} from "./vector-style";

    /**
     * @type {Feature[]}
     */
    export let features;

    export let envelope;
    export let gisLayer;
    export let soilMapUnitCode;

    export let baseLayerNames = ['topo_hybrid_grey'];
    export let contextLayerNames = ['water_transport_text'];
    export let attribution = `Map contains data sourced from LINZ. Crown Copyright Reserved`;
    export let mapLayersURL = `https://${wmtsMapHost()}/mapcache/portals/wmts/`;
    export let hdpi = true;

    /**
     * optional classes to add to the map target div
     * @type {string}
     */
    export let mapClass = '';

    export let mapOptions = {
        interactions: [],
        controls: [new ScaleLine()]
    };

    $: wmsLayer = mapUnitWMSLayer({ gisLayer, soilMapUnitCode, hdpi })

    export let zoom = 15;

    export let padding = [26, 26, 26, 26];

    const key = `FeatureMap:${uuid()}`
    const readyStore = getContext('readyStore');
    const printStore = getContext('printStore');

    readyStore.update(m => {
        const newM = new Map(m);
        newM.set(key, false);
        return newM;
    });

    let mapDiv;
    let map;
    const vectorSource = new VectorSource({ projection: "EPSG:2193" });
    const vectorLayer = new VectorLayer({source: vectorSource, style: vectorStyle});

    $: baseLayers = baseLayerNames.map((layerName) => wmtsLayer({ layerName, mapLayersURL, hdpi }));
    $: contextLayers = contextLayerNames.map((layerName) => wmtsLayer({ layerName, mapLayersURL, hdpi }));

    $: layers = [...baseLayers, wmsLayer, ...contextLayers, vectorLayer];

    let renderComplete = false;

    function resizeMap (    ) {
        if (map && envelope) {
            map.getView().fit(envelope, { size: map.getSize(), padding })
            console.log(map.getView().getZoom());
            /*const features = vectorSource.getFeatures();
            if (features.length === 1 && features[0].getGeometry() instanceof Point) {
                map.getView().setCenter(features[0].getGeometry().getCoordinates());
                map.getView().setZoom(zoom);
            } else {
                map.getView().fit(vectorSource.getExtent(), {size: map.getSize(), padding, maxZoom: 15})
                console.log(`map zoom ${map.getView().getZoom()}`)
            }*/

            console.log(`${map.getView().getCenter()}`);
        }
    }

    onMount(function () {
        // only access window after mount, otherwise this would break SSR
        map = new OlMap({
            ...mapOptions,
            pixelRatio: hdpi ? 2 : 1, // ensures the vector layer is rendered at the same dpi as the tile layers
            layers,
            target: mapDiv,
            view: new View({
                projection: "EPSG:2193",
                zoom,
                constrainResolution: true,
                smoothResolutionConstraint: true,
                resolutions
            })
        });

        resizeMap();
    });

    let dataUrl = transparentSrc;

    $: {
        if (vectorSource && features && features.length && map) {
            vectorSource.clear(true);
            renderComplete = false;
            vectorSource.addFeatures(features);
            // resizeMap();

            map.once('rendercomplete', function () {
                console.log('rendercomplete')

                try {
                    dataUrl = mapToSrcSync(map);
                } catch (e) {
                    console.warn(e);
                    dataUrl = transparentSrc;
                }
                renderComplete = true;
                tick().then(() => {
                    readyStore.update(m => {
                        const newM = new Map(m);
                        newM.set(key, true);
                        return newM;
                    });
                });
            })
        }
    }
</script>

<style>
    div :global(.ol-scale-line) {
        bottom: unset;
        right: unset;
        top: 8px;
        left: 8px;
    }

    div {
        background-color: #74adcd;
    }

    img.map-img {
        max-width: 100%;
        background-color: #74adcd;
    }

    @media print {
        .no-print {
            display: none !important;
        }
    }

    .attribution {
        font-size: small;
        text-align: right;
    }
</style>

<svelte:window on:resize={resizeMap}/>

<div class:no-print={renderComplete} bind:this={mapDiv} class={mapClass}></div>

<img class="print-only map-img" src={dataUrl} alt="map"/>

<p class="attribution">{attribution}</p>